import { useState } from 'react';
import api from '../services/api';

export interface CnpjLookupResult {
  razaoSocial?: string;
  nomeFantasia?: string;
  endereco?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  telefone?: string;
  email?: string;
}

/** Busca dados de CNPJ via proxy do backend (/saas/cnpj/:cnpj) — evita CORS/ad-blockers. */
export function useCnpjLookup() {
  const [buscando, setBuscando] = useState(false);
  const [erro, setErro] = useState('');

  async function buscar(cnpjRaw: string): Promise<CnpjLookupResult | null> {
    const cnpj = cnpjRaw.replace(/\D/g, '');
    if (cnpj.length !== 14) {
      setErro('CNPJ deve ter 14 dígitos');
      return null;
    }
    setErro('');
    setBuscando(true);
    try {
      const { data: d } = await api.get<any>(`/saas/cnpj/${cnpj}`);
      return {
        razaoSocial: d.razao_social || d.nome,
        nomeFantasia: d.nome_fantasia,
        endereco: d.logradouro,
        numero: d.numero,
        complemento: d.complemento,
        bairro: d.bairro,
        cidade: d.municipio,
        estado: d.uf,
        cep: d.cep,
        telefone: d.telefone,
        email: d.email,
      };
    } catch (err: any) {
      setErro(
        err?.response?.data?.message ||
        (err?.response?.status === 404
          ? 'CNPJ não encontrado na Receita Federal'
          : 'Erro ao buscar CNPJ. Verifique a conexão.'),
      );
      return null;
    } finally {
      setBuscando(false);
    }
  }

  return { buscar, buscando, erro, setErro };
}
